// extracted by mini-css-extract-plugin
export default {"resultCard":"ResultCard_resultCard__g0c5r","similarity":"ResultCard_similarity__Byc7F","contentSnippet":"ResultCard_contentSnippet__ST-lz"};